import { render, staticRenderFns } from "./PreviewForm17.vue?vue&type=template&id=6b9b7b1c&scoped=true"
import script from "./PreviewForm17.vue?vue&type=script&lang=ts"
export * from "./PreviewForm17.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b7b1c",
  null
  
)

export default component.exports